import { Button, Typography } from 'antd'
import React from 'react'
import { JOURNEYS_SERVICE } from '../../../Constants'
import { SVG } from './SVG'

import './SustainableEventBannerCompact.less'

const { Text } = Typography

interface SustainableEventBannerCompactProps {
  eventUUID: string
}

export const SustainableEventBannerCompact = ({
  eventUUID,
}: SustainableEventBannerCompactProps): JSX.Element => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      paddingLeft: '18px',
      paddingRight: '18px',
      background: '#FFF',
      border: '1px solid #4F987B',
      borderRadius: '4px',
    }}
  >
    <Text
      style={{
        flexGrow: 1,
        color: '#0E4433',
        fontWeight: 600,
        lineHeight: '24px',
      }}
    >
      Thank you for submitting travel details!
    </Text>
    <Button
      type="link"
      href={`${JOURNEYS_SERVICE}/${eventUUID}/journeys`}
      rel="noopener noreferrer"
      target="_blank"
      className="update-travel-information-button"
      style={{
        padding: 'unset',
        height: '100%',
        marginRight: '16px',
        color: '#187759',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '36px',
        border: 'unset'
      }}
    >
      Update Travel Information
    </Button>
    <div style={{ height: '48px' }}>
      <SVG />
    </div>
  </div>
)
